module.exports = __webpack_public_path__ + "static/media/17.83f8a061.jpg";